import React from 'react';
import pt from 'prop-types';
import Text from '../../../../ui/text';
import { combine } from '/src/helpers/styles';
import Link, { linkProptypes } from '../../../../ui/link';
import * as styles from './heroTeaser.module.scss';

const HeroTeaser = ({
  headline,
  text,
  cta,
  ctas,
  position,
  isRed,
  isEditorial,
  bigHeadline,
  className,
}) => (
  <div
    className={combine(
      styles.heroTeaser,
      position === 'left' && styles.leftAlign,
      !isRed && styles.isBlue,
      (isEditorial || bigHeadline) && styles.halfHalf,
      isEditorial && styles.isEditorial,
      className
    )}
  >
    {bigHeadline ? (
      <Text as="p" type="separator" className={styles.bigHeadline}>
        {bigHeadline}
      </Text>
    ) : (
      <>
        <div className={styles.contentContainer}>
          {headline && (
            <Text
              as="p"
              type={isEditorial ? 'h1' : 'headline_cond'}
              variant={isEditorial && 'editorial'}
              className={styles.hl}
            >
              {headline}
            </Text>
          )}
          {text && (
            <Text
              as="p"
              type="p1"
              variant={isEditorial ? 'editorial' : ''}
              className={styles.text}
            >
              {text}
            </Text>
          )}
        </div>
        {ctas?.length > 0 && (
          <div className={styles.ctasContainer}>
            {ctas.map((cta, idx) => (
              <Link
                key={cta.text}
                link={cta}
                asButton
                allowIcon
                className={combine(
                  styles.leftTopMargins,
                  idx === 1 && styles.secondCta,
                  styles.link
                )}
              >
                {cta.text}
              </Link>
            ))}
          </div>
        )}
        {/* Leave it as fallback for old design */}
        {!ctas?.length && cta && (
          <div>
            <Link
              link={cta}
              asButton
              allowIcon
              className={combine(styles.leftTopMargins, styles.link)}
            >
              {cta.text}
            </Link>
          </div>
        )}
      </>
    )}
  </div>
);

export const proptypes = {
  headline: pt.string,
  bigHeadline: pt.string,
  text: pt.string,
  cta: pt.shape(linkProptypes),
  ctas: pt.arrayOf(pt.shape(linkProptypes)),
  position: pt.string,
  isRed: pt.bool,
  className: pt.string,
};
HeroTeaser.propTypes = proptypes;

HeroTeaser.defaultProps = {
  headline: '',
  bigHeadline: '',
  position: 'right',
  isRed: true,
  className: '',
  ctas: [],
};

HeroTeaser.propTypes = proptypes;

export default HeroTeaser;
